var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container role-edit-box" }, [
    _c(
      "div",
      { staticClass: "common-header" },
      [
        _c("common-header", {
          attrs: {
            headerList: [
              { label: "系统管理", url: "" },
              { label: "角色管理", url: "/system/role" },
              { label: "角色信息", url: "" }
            ]
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            on: { "tab-click": _vm.handleClickTab },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                staticClass: "red_tabs",
                attrs: { label: "角色基本信息", name: "BASIC" }
              },
              [
                _c("div", { staticClass: "basic-info" }, [
                  _c(
                    "div",
                    { staticClass: "main" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "basic-top",
                          staticStyle: { "margin-top": "15px" }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "basicForm",
                              attrs: {
                                model: _vm.basicInfoFormData,
                                rules: _vm.basicRules,
                                "label-width": "80px",
                                "label-position": "top"
                              }
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "角色编号",
                                            prop: "roleId"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: {
                                              "max-width": "320px"
                                            },
                                            attrs: {
                                              placeholder: "请输入角色编号",
                                              maxlength: "32",
                                              "show-word-limit": "",
                                              disabled: !_vm.isAddOrUpdate
                                            },
                                            model: {
                                              value:
                                                _vm.basicInfoFormData.roleId,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.basicInfoFormData,
                                                  "roleId",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "basicInfoFormData.roleId"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "系统名称",
                                            prop: "systemId"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "max-width": "320px",
                                                display: "block"
                                              },
                                              attrs: {
                                                placeholder: "请选择系统名称",
                                                disabled: !_vm.isAddOrUpdate
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.systemSelectChange(
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.basicInfoFormData
                                                    .systemId,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.basicInfoFormData,
                                                    "systemId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "basicInfoFormData.systemId"
                                              }
                                            },
                                            _vm._l(_vm.systems, function(item) {
                                              return _c("el-option", {
                                                key: item.systemId,
                                                attrs: {
                                                  label: item.systemName,
                                                  value: item.systemId
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "角色名称",
                                            prop: "roleName"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticClass: "limit32",
                                            staticStyle: {
                                              "max-width": "320px"
                                            },
                                            attrs: {
                                              placeholder: "请输入角色名称",
                                              maxlength: "32",
                                              "show-word-limit": ""
                                            },
                                            model: {
                                              value:
                                                _vm.basicInfoFormData.roleName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.basicInfoFormData,
                                                  "roleName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "basicInfoFormData.roleName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "角色类型" } },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "max-width": "320px",
                                                display: "block"
                                              },
                                              attrs: {
                                                placeholder: "请选择角色类型"
                                              },
                                              model: {
                                                value:
                                                  _vm.basicInfoFormData
                                                    .roleType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.basicInfoFormData,
                                                    "roleType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "basicInfoFormData.roleType"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                key: "SYSTEM",
                                                attrs: {
                                                  label: "系统",
                                                  value: "SYSTEM"
                                                }
                                              }),
                                              _c("el-option", {
                                                key: "BUSINESS",
                                                attrs: {
                                                  label: "业务",
                                                  value: "BUSINESS"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "角色状态" } },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "max-width": "320px",
                                                display: "block"
                                              },
                                              attrs: {
                                                placeholder: "请选择系统名称"
                                              },
                                              model: {
                                                value:
                                                  _vm.basicInfoFormData
                                                    .roleStatus,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.basicInfoFormData,
                                                    "roleStatus",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "basicInfoFormData.roleStatus"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "有效",
                                                  value: "VALID"
                                                }
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "无效",
                                                  value: "INVALID"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 18 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "角色说明" } },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入角色说明"
                                            },
                                            model: {
                                              value:
                                                _vm.basicInfoFormData
                                                  .roleDescription,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.basicInfoFormData,
                                                  "roleDescription",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "basicInfoFormData.roleDescription"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "是否设定管辖部门" }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "max-width": "320px",
                                                display: "block"
                                              },
                                              attrs: {
                                                placeholder:
                                                  "请选择是否设定管辖部门"
                                              },
                                              model: {
                                                value:
                                                  _vm.basicInfoFormData
                                                    .canSetManageOrg,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.basicInfoFormData,
                                                    "canSetManageOrg",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "basicInfoFormData.canSetManageOrg"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                key: 1,
                                                attrs: { label: "是", value: 1 }
                                              }),
                                              _c("el-option", {
                                                key: 0,
                                                attrs: { label: "否", value: 0 }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: { label: "是否开启条线选择" }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "max-width": "320px",
                                                display: "block"
                                              },
                                              attrs: {
                                                placeholder:
                                                  "请选择是否开启条线选择"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.canSetBizLineSelectChange(
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.basicInfoFormData
                                                    .canSetBizLine,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.basicInfoFormData,
                                                    "canSetBizLine",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "basicInfoFormData.canSetBizLine"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                key: 1,
                                                attrs: { label: "是", value: 1 }
                                              }),
                                              _c("el-option", {
                                                key: 0,
                                                attrs: { label: "否", value: 0 }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "是否可以动态计算人员辖区"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                "max-width": "320px",
                                                display: "block",
                                                color: "#333"
                                              },
                                              attrs: {
                                                placeholder:
                                                  "请选择是否可以动态计算人员辖区"
                                              },
                                              model: {
                                                value:
                                                  _vm.basicInfoFormData
                                                    .autoComputeArea,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.basicInfoFormData,
                                                    "autoComputeArea",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "basicInfoFormData.autoComputeArea"
                                              }
                                            },
                                            [
                                              _c("el-option", {
                                                key: 1,
                                                attrs: { label: "是", value: 1 }
                                              }),
                                              _c("el-option", {
                                                key: 0,
                                                attrs: { label: "否", value: 0 }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content:
                                                  "如需要系统自动计算人员的管辖部门及管辖条线，此处应选“是”",
                                                placement: "top"
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-info icon-info"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-divider", { staticClass: "noMargin" }),
                      _c(
                        "div",
                        {
                          staticClass: "basic-bottom",
                          style: {
                            "min-height": "calc(100vh - 550px)"
                          }
                        },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("角色权限列表")
                          ]),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.tableLoading,
                                  expression: "tableLoading"
                                }
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.rolePermissions,
                                border: "",
                                "tooltip-effect": "dark",
                                "highlight-current-row": "",
                                height:
                                  _vm.screenHeight > 800
                                    ? "calc(100vh - 559px)"
                                    : "calc(100vh - 568px)",
                                "row-key": "id"
                              }
                            },
                            [
                              _c("template", { slot: "empty" }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      height: "100%",
                                      width: "100%",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center"
                                    }
                                  },
                                  [
                                    _c("no-data", {
                                      attrs: { height: "400px", width: "400px" }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _c("el-table-column", {
                                attrs: { width: "60" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-checkbox", {
                                          on: {
                                            change: function($event) {
                                              return _vm.handleCheckboxChange(
                                                $event,
                                                scope.row
                                              )
                                            }
                                          },
                                          model: {
                                            value: scope.row.isChosen,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "isChosen",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.isChosen"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "permissionId",
                                  label: "权限编码",
                                  width: "250",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "permissionName",
                                  label: "权限名称",
                                  width: "270",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "permissionDesc",
                                  label: "权限描述",
                                  width: _vm.screenHeight > 800 ? "880" : "500",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "updatedTime",
                                  label: "最后更新时间",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "updatedBy",
                                  label: "最后更新人",
                                  "show-overflow-tooltip": ""
                                }
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "footer-page",
                      staticStyle: { "padding-bottom": "20px" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "footer-btn-group" },
                        [
                          _c(
                            "el-popconfirm",
                            {
                              attrs: {
                                title:
                                  "确定要取消吗？取消后填写的数据将不会被保存"
                              },
                              on: {
                                onConfirm: function($event) {
                                  return _vm.confirmCancel(true)
                                },
                                onCancel: function($event) {
                                  return _vm.confirmCancel(false)
                                }
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn btn-red roleEditCancelBtn",
                                  attrs: { slot: "reference" },
                                  slot: "reference"
                                },
                                [_vm._v(" 取消 ")]
                              )
                            ],
                            1
                          ),
                          _vm.isAddOrUpdate
                            ? _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    title: "是否确定为此角色添加用户？"
                                  },
                                  on: {
                                    onConfirm: function($event) {
                                      return _vm.submit(true)
                                    },
                                    onCancel: function($event) {
                                      return _vm.submit(false)
                                    }
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "btn btn-red",
                                    staticStyle: {
                                      "margin-left": "20px",
                                      width: "68px"
                                    },
                                    attrs: {
                                      slot: "reference",
                                      type: "button",
                                      value: "提交"
                                    },
                                    slot: "reference"
                                  })
                                ]
                              )
                            : _vm._e(),
                          !_vm.isAddOrUpdate
                            ? _c("input", {
                                staticClass: "btn btn-red",
                                staticStyle: {
                                  "margin-left": "20px",
                                  width: "68px"
                                },
                                attrs: {
                                  slot: "reference",
                                  type: "button",
                                  value: "保存"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.save()
                                  }
                                },
                                slot: "reference"
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          background: "",
                          "hide-on-single-page": false,
                          total: _vm.rolePermissionPagination.total,
                          "current-page": _vm.rolePermissionPagination.pageNum,
                          "page-sizes": [10, 20, 50, 100, 1000, 2000],
                          "page-size": _vm.rolePermissionPagination.pageSize,
                          layout: "total, sizes, prev, pager, next, jumper"
                        },
                        on: {
                          "update:currentPage": function($event) {
                            return _vm.$set(
                              _vm.rolePermissionPagination,
                              "pageNum",
                              $event
                            )
                          },
                          "update:current-page": function($event) {
                            return _vm.$set(
                              _vm.rolePermissionPagination,
                              "pageNum",
                              $event
                            )
                          },
                          "update:pageSize": function($event) {
                            return _vm.$set(
                              _vm.rolePermissionPagination,
                              "pageSize",
                              $event
                            )
                          },
                          "update:page-size": function($event) {
                            return _vm.$set(
                              _vm.rolePermissionPagination,
                              "pageSize",
                              $event
                            )
                          },
                          "current-change": _vm.rolePermissionCurrentChange,
                          "size-change": _vm.rolePermissionSizeChange
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm.showUserTab
              ? _c(
                  "el-tab-pane",
                  { attrs: { label: "用户列表", name: "USERS" } },
                  [
                    _c("div", { staticClass: "users" }, [
                      _c(
                        "div",
                        { staticClass: "main" },
                        [
                          _c(
                            "div",
                            { staticClass: "users-top" },
                            [
                              _c(
                                "el-row",
                                { staticClass: "row" },
                                [
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _vm._v(
                                      " 角色编号：" +
                                        _vm._s(_vm.basicInfoFormData.roleId) +
                                        " "
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _c("div", [
                                      _vm._v(
                                        " 系统名称：" +
                                          _vm._s(
                                            _vm._f("filterBiz")(
                                              _vm.basicInfoFormData.systemId,
                                              this.systems
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]),
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _c("div", [
                                      _vm._v(
                                        "角色名称：" +
                                          _vm._s(_vm.basicInfoFormData.roleName)
                                      )
                                    ])
                                  ]),
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _c("div", [
                                      _vm._v(
                                        " 角色类型：" +
                                          _vm._s(
                                            _vm.basicInfoFormData.roleType ===
                                              "BUSINESS"
                                              ? "业务"
                                              : "系统"
                                          ) +
                                          " "
                                      )
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { staticClass: "row" },
                                [
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _c("div", [
                                      _vm._v(
                                        " 角色状态：" +
                                          _vm._s(
                                            _vm._f("filterValidType")(
                                              _vm.basicInfoFormData.roleStatus
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]),
                                  _c("el-col", { attrs: { span: 18 } }, [
                                    _c("div", [
                                      _vm._v(
                                        "角色说明：" +
                                          _vm._s(
                                            _vm.basicInfoFormData
                                              .roleDescription
                                          )
                                      )
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                { staticClass: "row" },
                                [
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _vm._v(
                                      " 是否设定管辖部门：" +
                                        _vm._s(
                                          _vm._f("filterNumberType")(
                                            _vm.basicInfoFormData
                                              .canSetManageOrg
                                          )
                                        ) +
                                        " "
                                    )
                                  ]),
                                  _c("el-col", { attrs: { span: 6 } }, [
                                    _c("div", [
                                      _vm._v(
                                        " 是否开启条线选择：" +
                                          _vm._s(
                                            _vm._f("filterNumberType")(
                                              _vm.basicInfoFormData
                                                .canSetBizLine
                                            )
                                          ) +
                                          " "
                                      )
                                    ])
                                  ]),
                                  _c("el-col", { attrs: { span: 12 } }, [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          "margin-top": "-10px"
                                        }
                                      },
                                      [
                                        _vm._v(" 是否可以动态计算人员辖区： "),
                                        _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              width: "320px",
                                              color: "#333"
                                            },
                                            attrs: {
                                              placeholder:
                                                "请选择是否可以动态计算人员辖区"
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.autoComputeAreaChange(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.basicInfoFormData
                                                  .autoComputeArea,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.basicInfoFormData,
                                                  "autoComputeArea",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "basicInfoFormData.autoComputeArea"
                                            }
                                          },
                                          [
                                            _c("el-option", {
                                              key: 1,
                                              attrs: { label: "是", value: 1 }
                                            }),
                                            _c("el-option", {
                                              key: 0,
                                              attrs: { label: "否", value: 0 }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content:
                                                "如需要系统自动计算人员的管辖部门及管辖条线，此处应选“是”",
                                              placement: "top"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-info user-icon-info"
                                            })
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("el-divider")
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "sub-tabs" },
                        [
                          _c(
                            "el-tabs",
                            {
                              on: { "tab-click": _vm.handleUsersTabClick },
                              model: {
                                value: _vm.activeUserTabName,
                                callback: function($$v) {
                                  _vm.activeUserTabName = $$v
                                },
                                expression: "activeUserTabName"
                              }
                            },
                            [
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: "固定用户列表",
                                    name: "REGULAR"
                                  }
                                },
                                [
                                  _vm.basicInfoFormData.roleId &&
                                  _vm.basicInfoFormData.systemId
                                    ? _c("Regular-Users", {
                                        attrs: {
                                          "basic-info-form-data":
                                            _vm.basicInfoFormData,
                                          "if-add-or-edit": _vm.isAddOrUpdate
                                        },
                                        on: {
                                          "update:basicInfoFormData": function(
                                            $event
                                          ) {
                                            _vm.basicInfoFormData = $event
                                          },
                                          "update:basic-info-form-data": function(
                                            $event
                                          ) {
                                            _vm.basicInfoFormData = $event
                                          },
                                          "update:ifAddOrEdit": function(
                                            $event
                                          ) {
                                            _vm.isAddOrUpdate = $event
                                          },
                                          "update:if-add-or-edit": function(
                                            $event
                                          ) {
                                            _vm.isAddOrUpdate = $event
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm.basicInfoFormData.autoComputeArea
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      attrs: {
                                        label: "动态人员列表",
                                        name: "DYNAMIC"
                                      }
                                    },
                                    [
                                      _vm.basicInfoFormData.roleId &&
                                      _vm.basicInfoFormData.systemId
                                        ? _c("Dynamic-Users", {
                                            attrs: {
                                              "basic-info-form-data":
                                                _vm.basicInfoFormData,
                                              "role-permissions":
                                                _vm.rolePermissions
                                            },
                                            on: {
                                              "update:basicInfoFormData": function(
                                                $event
                                              ) {
                                                _vm.basicInfoFormData = $event
                                              },
                                              "update:basic-info-form-data": function(
                                                $event
                                              ) {
                                                _vm.basicInfoFormData = $event
                                              },
                                              "update:rolePermissions": function(
                                                $event
                                              ) {
                                                _vm.rolePermissions = $event
                                              },
                                              "update:role-permissions": function(
                                                $event
                                              ) {
                                                _vm.rolePermissions = $event
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }